import axios from 'axios';
import config from "../config";

const BASE_URL = `${config.apiUrl}/notifications`;

export default {

    index(language) {
        return axios.get(`${BASE_URL}?language=${language}`).then(result => result.data);
    },
    store(data) {
        return axios.post(`${BASE_URL}`, data).then(result => result.data);
    },
    show(id) {
        return axios.get(`${BASE_URL}/${id}`).then(result => result.data);
    },
    byNotificationId(id) {
        return axios.get(`${BASE_URL}/id/${id}`).then(result => result.data);
    },
    update(notification) {
        return axios.put(`${BASE_URL}/${notification.id}`, notification).then(result => result.data);
    },
    destroy(notification) {
        return axios.delete(`${BASE_URL}/${notification.id}`).then(result => result.data);
    },
}
